class BESSAppProjectEditorFilterBuildingClassType extends BESSAppProjectEditorAttributeFilter {
    constructor(editor, container) {
        super(editor,
            container.find('.app-filter-building-class-type'),
            editor.data.distinctItemValues('type'),
            'type',
            'Types'
        );
    }

    updateState() {
        this.updateIsValid(this.editor.data.distinctItemValues('type').length > 1);
    }
}